export enum Locale {
  EN = 'en',
  TW = 'zh-hant',
}
